import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { CreateOrganisationDto } from "@classview/shared-types";
import { UseMutationOptions, useMutation } from "@tanstack/react-query";

const createOrganisation = async (
  organisation: CreateOrganisationDto,
): Promise<{ id: number }> => {
  const response = await axiosClient.post("/organisations", organisation);
  return response.data;
};

function useCreateOrganisation(
  mutationOptions?: UseMutationOptions<
    { id: number },
    HttpError,
    CreateOrganisationDto
  >,
) {
  return useMutation({
    mutationFn: createOrganisation,
    ...mutationOptions,
  });
}

export { useCreateOrganisation };
